// extracted by mini-css-extract-plugin
module.exports = {"icons":"_footer-icons-module--icons--14zHk"};